module.exports = __webpack_public_path__ + "static/media/google-play-badge@3x.e7d89937.jpg";